module.exports = __webpack_public_path__ + "img/chart_reduce.491067ea.svg";